import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        container: {
        },

        image: {
        },

        loadingIndicator: {
            color: theme.statusLoadingIndicatorColor,
        },
    };
};

export default getTheme;
